/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'
import { generateCampaignFormalitySchema } from './GenerateCampaignFormalitySchema'

export const generateCampaignSchema = z.object({
	organisationId: z.string().uuid(),
	campaignId: z.string().uuid(),
	jobTitle: z.string(),
	jobDescription: z.string(),
	jobLocation: z.string(),
	colorScheme: z.string(),
	additionalInstructions: z.string(),
	language: z.string(),
	targetAudience: z.string().nullable().optional(),
	toneOfVoice: z.string().nullable().optional(),
	visualGuidance: z.string().nullable().optional(),
	prompt: z.string().nullable().optional(),
	formality: generateCampaignFormalitySchema.nullable().optional(),
})

export type GenerateCampaignSchema = z.infer<typeof generateCampaignSchema>
